<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M4.003 13.99a2 2 0 0 1 1.5-1.937v-1.1a3 3 0 0 1 0-5.917v-1.1a2 2 0 1 1 1 0v1.1A3 3 0 0 1 8.41 6.2l1.167-.673a2 2 0 1 1 .5.866l-1.211.7a3.018 3.018 0 0 1 0 1.8l1.212.7a1.994 1.994 0 1 1-.5.865L8.41 9.78a3 3 0 0 1-1.908 1.17v1.1a2 2 0 1 1-2.5 1.94Z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering184',
});
</script>
